module.exports = __webpack_public_path__ + "static/media/f_eyeshape_upturned_blue.fa76df61.png";